
  import { defineComponent, ref } from 'vue';
  import { t } from '@/ui/i18n/i18n';

  interface CopyButtonProps {
    label?: string;
    text: string;
    copyText?: string;
    copiedText?: string;
  }

  export default defineComponent<CopyButtonProps>({
    props: ['label', 'text', 'copyText', 'copiedText'],
    setup(props) {
      const copy = props.copyText || t('analytics.share-report.copy');
      const showIcon = ref(true);
      const buttonLabel = ref(copy);

      const onClick = () => {
        navigator.clipboard.writeText(props.text).then(() => {
          buttonLabel.value = props.copiedText || t('analytics.share-report.copied');
          showIcon.value = false;

          setTimeout(() => {
            buttonLabel.value = copy;
            showIcon.value = true;
          }, 2000);
        }).catch(() => {
          console.error('Failed to copy text');
        });
      };

      return {
        buttonLabel,
        showIcon,
        onClick,
      };
    },
  });
